import strings from "../../../localization";
import { addBusinessYearStartValue, editBusinessYearStartValue } from "../../../Services/Finance/BusinessYearStartValueService";
import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import { getBankAccounts } from "../../../Services/Company/BankAccountService";
import BusinessYearStartValueForm from "../../../Components/Forms/Pages/Administration/BusinessYearStartValue/BusinessYearStartValueForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'bankAccount': {required: true},
    'amount': {required: true}
}

const AddBusinessYearStartValue = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [bankAccounts, setBankAccounts] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.administration.bussinesYearStartValue.addBussinesYearStartValue.pageTitle);
    })

    useEffect(() => {
        fetch();
    }, [])

    const onSubmit = (data) => {
        setShowLoader(true);

        addBusinessYearStartValue({
            businessYearId: props.businessYear,
            ...data
        }).then(response => {
            setShowLoader(false);
            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const fetch = () => {
        getBankAccounts().then(response => {
            if (!response || !response.ok){
                return;
            }

            setBankAccounts(response.data.result);
        })
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <BusinessYearStartValueForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                errors={errors} data={data} form={form} control={control}
                bankAccounts={bankAccounts}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddBusinessYearStartValue;
